export default "__VITE_ASSET__CZGbuyjV__"